<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" :busy="isBusy" stacked="lg" :selectable="selectable" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table" @row-selected="onRowSelected">
					<template #table-busy>
						<div class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong> Caricamento dati in corso...</strong>
						</div>
					</template>
					<template v-slot:cell(statoAttuale)="row">
						<b-container class="bv-example-row">
							<stati-colors :statoLabel="row.item.statoAttuale"></stati-colors>
						</b-container>
					</template>
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button v-if="!associazione" v-b-tooltip.hover title="Modifica Dati Progetto" size="sm" variant="outline-secondary" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
								<b-icon icon="pencil" variant="outline-secondary"></b-icon>
							</b-button>
							<b-button v-if="!associazione" v-b-tooltip.hover title="Calcella Progetto" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onClickDelete(row.item, row.index, $event.target)">
								<b-icon icon="trash"></b-icon>
							</b-button>
							<b-button v-if="associazione" v-b-tooltip.hover title="Rimuovi Associazione" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onClickRimuoviAssociazione(row.item, row.index, $event.target)">
								<b-icon icon="trash"></b-icon>
							</b-button>
							<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Dettagli" @click="onClickDetails(row.item, row.index, $event.target)" class="mr-1 no-text">
								<i class="fab fa-creative-commons-nd"></i>
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import StatiColors from "../utility/StatiColors.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	props: {
		selectable: { type: Boolean, default: false },
	},
	components: { StatiColors },
	data() {
		return {
			isBusy: false,
			rows: 0,
			perPage: 50,
			currentPage: 1,
			pathResource: "/gestioneattivitaprogetti",
			pathResourceAssociazione: "/gestioneattivitaassetattivita",
			linkedit: "/gestioneattivita/progetti",
			progettiFilter: {},
			btnAggiungi: false,
			items: [],
			selectionRows: [],
			associazione: false,
			fields: [
				{
					label: "Nome",
					key: "nome",
					sortable: true,
					thStyle: "width: 16rem",
				},
				{
					label: "Descrizione",
					key: "descrizione",
					sortable: true,
				},
				{
					label: "Data Fine",
					key: "dataOraInizio",
					thStyle: "width: 8rem",
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD/MM/YYYY");
						} else {
							return "-----";
						}
					},
					sortable: true,
				},
				{
					label: "Data Fine",
					key: "dataOraFine",
					thStyle: "width: 8rem",
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD/MM/YYYY");
						} else {
							return "-----";
						}
					},
					sortable: true,
				},
				{
					label: "Stato",
					key: "statoAttuale",
					sortable: true,
					thStyle: "width: 11rem",
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	methods: {
		init(params) {
			let me = this;
			me.loadData(params);
		},
		loadData(filter) {
			let me = this;
			me.progettiFilter.tipo = filter.tipo;
			switch (filter.tipo) {
				case "PRODOTTO":
					me.linkedit = "/gestioneattivita/prodotti";
					break;
				case "PROGETTO":
					me.linkedit = "/gestioneattivita/progetti";
					break;
			}

			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource, filter, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
		loadFromAttivita(pathResource, filter) {
			let me = this;
			me.associazione = true;
			me.isBusy = true;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(pathResource, filter, me.loadFromAttivitaSuccess, me.loadFromAttivitaError);
		},
		loadFromAttivitaSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			me.isBusy = false;
			me.$emit("afterLoadData");
		},
		loadFromAttivitaError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
			me.isBusy = false;
		},
		onEdit(item) {
			let me = this;
			me.$router.replace(me.linkedit + "/edit/" + item.id).catch((err) => {
				err;
			});
		},
		onClickAggiungi() {},
		onClickDelete(item) {
			let me = this;
			this.$bvModal
				.msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
					title: "Titolo",
					buttonSize: "sm",
					okVariant: "secondary",
					cancelVariant: "danger",
					okTitle: "SI",
					cancelTitle: "NO",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true,
				})
				.then(() => {
					me.deleteProject(item);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		deleteProject(item) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource;
			axios.delete(link + "/" + item.id).then(() => {
				this.$bvToast.toast("Progetto Rimosso Correttamente", {
					title: this.titleModal,
					variant: "success",
					autoHideDelay: 5000,
				});

				me.loadData();
			});
		},
		onRowSelected(items) {
			let me = this;
			me.selectionRows = items;
		},
		getSelectionRows() {
			return this.selectionRows;
		},
		onClickRimuoviAssociazione(item) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceAssociazione;
			axios.delete(link + "/" + item.idAssociazione).then(() => {
				this.$bvToast.toast("Associazione Rimossa Correttamente", {
					title: this.titleModal,
					variant: "success",
					autoHideDelay: 5000,
				});

				me.$emit("afterRimuoviAssociazione");
			});
		},
		onClickDetails(item) {
			let me = this;
			me.$router.replace(me.linkedit + "/dettaglio/" + item.id).catch((err) => {
				err;
			});
		},
	},
};
</script>

<style></style>
